import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Href, JustifyContent, TextLeft } from "../../../../Constant";
import { JUSTIFY_DATA, JUSTIFY_LIST } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const JustifyContents = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={JustifyContent} span={JUSTIFY_DATA} />
        <CardBody className="dropdown-basic m-0">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="primary" className="text-white">{TextLeft}</DropdownToggle>
                <DropdownMenu className="dropdown-block text-start">
                  <DropdownItem href={Href}>Hello..</DropdownItem>
                  <DropdownItem href={Href}>How are you?</DropdownItem>
                  <DropdownItem href={Href}>What are you doing?</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {JUSTIFY_LIST.map((data, index) => (
              <CommonDropDown item={data} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default JustifyContents;
